// select gid 002 and select date 2022/4/12 ~ 2022/4/14 to get table data
import React, { useState, useEffect, useRef, useContext } from "react";
import { registerLocale } from "react-datepicker";
import { useParams, useHistory } from "react-router-dom";
import { addDays } from "date-fns";
import zhCN from "date-fns/locale/zh-CN";
import { v4 as uuidv4 } from "uuid";
import Container from "components/common/Container";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
import Result from "components/pages/DailyRecord/Result";
import ButtonGroup from "components/pages/DailyRecord/ButtonGroup";
import { DailyDetail } from "../styles/DailyRecord";
import DailyRecordTable from "components/pages/DailyRecord/DailyRecordTable";
import { IMessage, IMessageTBGroup } from "../api_types";
import { MonkeyPatchedIMessage } from "../client_types";
import { Spin, TablePaginationConfig, notification } from "antdv5";
import Searchbox from "components/pages/DailyRecord/Searchbox";
import {
  GETJsonMessageTbgroupNoToken,
  GETJsonMessageDaily,
  GETJsonDailyExportData,
} from "../api";
import useEffectOnce from "components/customHook/useEffectOnce";
import type { Obj } from "../client_types";
import { context } from "components/context/Context";
import XLSX from "xlsx";

registerLocale("zh", zhCN);
const obsKeyToString = (o: Obj, k: any[], sep: string) => {
  return k.reduce(
    (str, key) =>
      str + (o.hasOwnProperty(key) ? (str.length > 0 ? sep : "") + o[key] : ""),
    ""
  );
};
const formatDate = (date: Date) =>
  Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .format(date as Date)
    .replace(/\//g, "-");
const keys = ["HH", "MM", "SS"];
const FFkey = ["FF"];
const longtitude = ["Avela", "Avefen", "Avesec"];
const latitude = ["Avnla", "Avnfen", "Avnsec"];

const DailyRecord = () => {
  const {
    handleAuth,
    preventRefreshCount,
    loading: spinLoading,
    handleEnter,
  } = useAPI();
  const { dispatch, state } = useContext(context);
  const history = useHistory();
  const [api, ctx] = notification.useNotification();
  const [data, setData] = useState<{
    data: MonkeyPatchedIMessage[];
    count: number | null;
  }>({
    data: [],
    count: 0,
  });
  const [rank, setRank] = useState<"ASC" | "DES">("ASC");
  const [sortText, setSortText] = useState<"正序" | "倒序">("正序");
  const [findName, setFindName] = useState({
    searchFeetNo: "",
    searchName: "",
    memberName: "",
  });
  const [pageInfo, setPageInfo] = useState<{
    pageSize: number | null | undefined;
    current: number | null | undefined;
  }>({
    pageSize: null,
    current: null,
  });
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    new Date(),
    new Date(),
  ]);
  const [startDate, endDate] = dateRange;
  const [clubList, setClubList] = useState<IMessageTBGroup[]>([]);
  const [nowClub, setNowClub] = useState(
    `${state.clubID} - ${localStorage.getItem("clubName")}`
  );
  const [clubGid, setClubGid] = useState(
    localStorage.getItem("gid") || "选择鸽会"
  );
  const [isChecked, setIsChecked] = useState(true);
  const [storageTime, setStorageTime] = useState<
    [string | null, string | null]
  >(["", ""]);
  const [storageSearchValue, setStorageSearchValue] = useState({
    feetNo: "",
    matchNumber: "",
    memberName: "",
  });
  const [storageIsCheck, setStorageIsCheck] = useState<boolean | null>(null);
  const [lock, setLock] = useState(true);
  const [lockInput, setLockInput] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const firstRender = useRef<boolean>(false);

  const handleMenuClick = (e: { key: string }) => {
    if (parseInt(e.key) === 1) {
      setRank("ASC");
      setSortText("正序");
    } else if (parseInt(e.key) === 2) {
      setRank("DES");
      setSortText("倒序");
    }
  };
  const fetchClubList = async () => {
    setClubList(await GETJsonMessageTbgroupNoToken());
  };
  const fetchData = () => {
    setLoading(true);
    setLock(true);
    setLockInput(true);
    setPageInfo({ pageSize: 100, current: 1 });
    if (startDate !== null && endDate !== null) {
      let startTime = Intl.DateTimeFormat("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
        .format(startDate as Date)
        .replace(/\//g, "-");
      let endTime = Intl.DateTimeFormat("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
        .format(endDate as Date)
        .replace(/\//g, "-");
      setStorageIsCheck(isChecked);
      setStorageTime([startTime, endTime]);
      setStorageSearchValue({
        feetNo: findName.searchFeetNo,
        matchNumber: findName.searchName,
        memberName: findName.memberName,
      });
      GETJsonMessageDaily(
        clubGid,
        startTime,
        endTime,
        rank,
        pageInfo.pageSize || 100,
        pageInfo.current || 1,
        findName.searchFeetNo,
        findName.searchName,
        findName.memberName,
        isChecked
      ).then((res) => {
        let result: MonkeyPatchedIMessage[] = [];
        if (res && res.length > 0) {
          res.forEach((elem: IMessage, i: number) => {
            const backTime = obsKeyToString(elem, keys, ":");
            const FFTime = obsKeyToString(elem, FFkey, ".");
            const timeData = backTime + "." + FFTime;
            const eastLongtitude = obsKeyToString(elem, longtitude, "'");
            const northLatitude = obsKeyToString(elem, latitude, "'");
            if (rank === "ASC") {
              result.push({
                ...elem,
                rank: i + 1,
                stringDate: timeData,
                east: eastLongtitude,
                north: northLatitude,
                id: uuidv4(),
              });
            } else {
              result.push({
                ...elem,
                rank: res[0].Count - i,
                stringDate: timeData,
                east: eastLongtitude,
                north: northLatitude,
                id: uuidv4(),
              });
            }
          });
          setData({ data: result, count: res[0].Count });
          setLoading(false);
          setLock(false);
          setLockInput(false);
        } else {
          setLoading(false);
          api.info({
            message: "注意！",
            description: "查无资料",
            placement: "top",
          });
          setData({ data: [], count: 0 });
          setLock(false);
          setLockInput(false);
        }
      });
    } else {
      setLoading(false);
      setLock(false);
      setLockInput(false);
    }
  };
  const fetchNewData = (pageSize = 100, current = 1) => {
    setLoading(true);
    if (storageTime.length > 0) {
      GETJsonMessageDaily(
        clubGid,
        storageTime[0] || formatDate(new Date()),
        storageTime[1] || formatDate(new Date()),
        rank,
        pageSize,
        current,
        storageSearchValue.feetNo,
        storageSearchValue.matchNumber,
        storageSearchValue.memberName,
        storageIsCheck || false
      ).then((res) => {
        if (res && res.length > 0) {
          let result: MonkeyPatchedIMessage[] = [];
          if (rank === "ASC") {
            if (pageSize === 20) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: (current - 1) * 20 + 1 + i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            } else if (pageSize === 50) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: (current - 1) * 50 + 1 + i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            } else if (pageSize === 100) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: (current - 1) * 100 + 1 + i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            }
          } else {
            if (pageSize === 20) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: res[0].Count - (current - 1) * 20 - i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            } else if (pageSize === 50) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: res[0].Count - (current - 1) * 50 - i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            } else if (pageSize === 100) {
              res.forEach((elem: IMessage, i: number) => {
                const backTime = obsKeyToString(elem, keys, ":");
                const FFTime = obsKeyToString(elem, FFkey, ".");
                const timeData = backTime + "." + FFTime;
                const eastLongtitude = obsKeyToString(elem, longtitude, "'");
                const northLatitude = obsKeyToString(elem, latitude, "'");
                result.push({
                  ...elem,
                  rank: res[0].Count - (current - 1) * 100 - i,
                  stringDate: timeData,
                  east: eastLongtitude,
                  north: northLatitude,
                  id: uuidv4(),
                });
              });
              setData({
                data: result,
                count: res[0].Count,
              });
            }
          }
        } else {
          api.info({
            message: "注意！",
            description: "查无资料",
            placement: "top",
          });
          setData({ data: [], count: 0 });
        }
        setLoading(false);
        setLock(false);
        setLockInput(false);
      });
    } else {
      setLoading(false);
      // setLock(false)
      setLockInput(false);
    }
  };
  const onTableChange = (pagination: TablePaginationConfig) => {
    handleAuth();
    setPageInfo({
      pageSize: pagination.pageSize,
      current: pagination.current,
    });
    fetchNewData(pagination.pageSize, pagination.current);
  };
  const handleCurrentPage = () => {
    let result = null;
    if (pageInfo.current === null) {
      result = 1;
    } else {
      result = pageInfo.current;
    }
    return result;
  };
  const handleDateSelect = () => {
    let firstDate = [startDate];
    for (let i = 1; i < 3; i++) {
      firstDate.push(addDays(startDate as Date, i));
    }
    return firstDate;
  };
  const handleDownload = async () => {
    setLoading(true);
    if (
      window.confirm(
        `请确认汇出档案日期: ${storageTime[0]} 至 ${storageTime[1]} 参赛编号: ${
          storageSearchValue.matchNumber ? storageSearchValue.matchNumber : "无"
        } 参赛名称：${
          storageSearchValue.memberName ? storageSearchValue.memberName : "无"
        } 足环号：${
          storageSearchValue.feetNo ? storageSearchValue.feetNo : "无"
        }`
      )
    ) {
      const parsedData = await GETJsonDailyExportData(
        clubGid,
        storageTime[0],
        storageTime[1],
        rank,
        storageSearchValue.feetNo,
        storageSearchValue.matchNumber,
        storageSearchValue.memberName,
        storageIsCheck,
        localStorage.getItem("token") || ""
      );
      let result: MonkeyPatchedIMessage[] = [];
      parsedData.forEach((elem: IMessage, i: number) => {
        const backTime = obsKeyToString(elem, keys, ":");
        const FFTime = obsKeyToString(elem, FFkey, ".");
        const timeData = backTime + "." + FFTime;
        const eastLongtitude = obsKeyToString(elem, longtitude, "'");
        const northLatitude = obsKeyToString(elem, latitude, "'");
        if (rank === "ASC") {
          result.push({
            ...elem,
            rank: i + 1,
            stringDate: timeData,
            east: eastLongtitude,
            north: northLatitude,
            id: uuidv4(),
          });
        } else {
          result.push({
            ...elem,
            rank: parsedData[1].Count - i,
            stringDate: timeData,
            east: eastLongtitude,
            north: northLatitude,
            id: uuidv4(),
          });
        }
      });
      let printData: Obj[] = [];
      result.map((d) =>
        printData.push({
          序号: d.rank.toString(),
          参赛编号: d.House,
          参赛名称: d.Name,
          环号: d.Ring,
          日期: d.Ymd,
          归巢时间: d.stringDate,
          备注: "",
        })
      );
      dataToXlsx(printData);
      setLoading(false);
    } else {
      setLoading(false);
      return;
    }
  };
  function useDebounce<T>(fn: T, delay: number) {
    const ref = useRef<{ fn: T; timer: any }>({ fn, timer: null });

    useEffect(() => {
      ref.current.fn = fn;
    }, [fn]);

    function f(...args: any[]) {
      if (ref.current.timer) {
        clearTimeout(ref.current.timer);
      }
      ref.current.timer = setTimeout(function (this: any) {
        (ref.current.fn as Function).call(this, ...args);
      }, delay);
    }

    return f as T;
  }
  const searchData = useDebounce<() => void>(fetchData, 100);
  const searchNewData = useDebounce<
    (pageSize: number, current: number) => void
  >(fetchNewData, 100);
  const handleSearch = () => {
    setPageInfo({ pageSize: null, current: null });
    preventRefreshCount(searchData, 3);
  };
  const fakePreventRefresh = (): false => {
    return false;
  };
  const dataToXlsx = async (tableData: Obj[]) => {
    if (tableData) {
      const sheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      sheet["!cols"] = [
        { wch: 10 },
        { wch: 12 },
        { wch: 30 },
        { wch: 20 },
        { wch: 10 },
        { wch: 12 },
      ];
      XLSX.utils.book_append_sheet(workbook, sheet, "workbook");
      XLSX.writeFile(workbook, "资料表.xlsx");
    } else {
      return;
    }
  };
  useEffectOnce(() => fetchClubList(), []);
  // fetchNewData() 需要等rank更新後才能觸發, firstRender用於
  // 避免網頁第一次渲染時觸發這個useEffect
  useEffect(() => {
    if (!firstRender.current) {
      firstRender.current = true;
      return;
    } else {
      fetchNewData(pageInfo.pageSize || 100, pageInfo.current || 1);
    }
  }, [rank]);
  useEffect(() => {
    handleAuth();
    preventRefreshCount(fakePreventRefresh, 3);
  }, [clubGid, rank]);
  useEffect(() => {
    setFindName({ searchFeetNo: "", searchName: "", memberName: "" });
    setData({ data: [], count: null });
    setStorageTime(["", ""]);
    setStorageSearchValue({
      feetNo: "",
      matchNumber: "",
      memberName: "",
    });
    setStorageIsCheck(null);
  }, [clubGid]);

  // replace
  // useEffect(() => {
  //   console.log("DailyRecord/clubID:", clubID);
  //   if (clubList?.length > 0) {
  //     const urlToClubOpt = clubList.find((data) => data.Clubid === clubID);
  //     if (urlToClubOpt) {
  //       const urlToString = `${urlToClubOpt.Clubid} - ${urlToClubOpt.ClubName}`;
  //       dispatch({ clubID });
  //       localStorage.setItem("clubName", urlToClubOpt.ClubName);
  //       localStorage.setItem("gid", urlToClubOpt.Gid);
  //       setNowClub(urlToString);
  //       setClubGid(urlToClubOpt.Gid);
  //     } else {
  //       api.info({
  //         message: "注意！",
  //         description: "查无鸽会",
  //         placement: "top",
  //       });
  //       history.push("001");
  //     }
  //   } else {
  //     return;
  //   }
  // }, [clubList, clubID]);

  return (
    <>
      {ctx}
      <DefaultLayout>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <DailyDetail>
            <Container>
              <div className="functionBox">
                <Searchbox
                  clubList={clubList}
                  nowClub={nowClub}
                  setNowClub={setNowClub}
                  setClubGid={setClubGid}
                  setFindName={setFindName}
                  findName={findName}
                  lockInput={lockInput}
                  handleSearch={handleSearch}
                  endDate={endDate}
                  handleEnter={handleEnter}
                  startDate={startDate}
                  setDateRange={setDateRange}
                  setLock={setLock}
                  inputRef={inputRef}
                  handleDateSelect={handleDateSelect}
                />
                <ButtonGroup
                  endDate={endDate}
                  isChecked={isChecked}
                  searchData={searchData}
                  pageInfo={pageInfo}
                  preventRefreshCount={preventRefreshCount}
                  handleAuth={handleAuth}
                  setFindName={setFindName}
                  setPageInfo={setPageInfo}
                  setRank={setRank}
                  setSortText={setSortText}
                  setDateRange={setDateRange}
                  setData={setData}
                  setStorageIsCheck={setStorageIsCheck}
                  setStorageTime={setStorageTime}
                  setStorageSearchValue={setStorageSearchValue}
                  setLock={setLock}
                  setIsChecked={setIsChecked}
                  fetchNewData={fetchNewData}
                />
              </div>
            </Container>
            <Result
              storageTime={storageTime}
              storageSearchValue={storageSearchValue}
              storageIsCheck={storageIsCheck}
            />
            <DailyRecordTable
              storageSearchValue={storageSearchValue}
              data={data}
              pageInfo={pageInfo}
              sortText={sortText}
              loading={loading}
              setStorageSearchValue={setStorageSearchValue}
              setPageInfo={setPageInfo}
              setLockInput={setLockInput}
              setLock={setLock}
              preventRefreshCount={preventRefreshCount}
              searchData={searchData}
              searchNewData={searchNewData}
              handleAuth={handleAuth}
              fetchNewData={fetchNewData}
              fakePreventRefresh={fakePreventRefresh}
              handleCurrentPage={handleCurrentPage}
              onTableChange={onTableChange}
              handleDownload={handleDownload}
              handleMenuClick={handleMenuClick}
            />
          </DailyDetail>
        </Spin>
      </DefaultLayout>
    </>
  );
};

export default DailyRecord;
